import Button from '@atlaskit/button';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { messages } from './messages';
export type SocialSignupErrorProps = {
  readonly tryAgainUrl: string;
  readonly errorImageSrc: string;
  readonly wacEnvUrl: string;
};
export function SocialSignupErrorView(props: SocialSignupErrorProps) {
  const { tryAgainUrl, errorImageSrc, wacEnvUrl } = props;
  const onButtonClick = () => {
    window.location.assign(tryAgainUrl);
  };
  const contactUsUrl = `${wacEnvUrl}/company/contact/purchasing-licensing`;
  return (
    <Root>
      <img src={errorImageSrc} alt={'loading...'} width={100} />
      <FormattedHTMLMessage {...messages.socialSignUpSomethingWentWrong} />
      <Button appearance={'primary'} onClick={onButtonClick}>
        Try signing up again
      </Button>
      <Bar></Bar>
      <ContactUs>
        <SanitizedFormattedHtmlMessage
          {...messages.socialSignUpErrorTextContactUs}
          values={{ contactUsUrl }}
        />
      </ContactUs>
      <FormattedHTMLMessage
        {...messages.socialSignUpSorryForTheInconvenience}
      />
    </Root>
  );
}
const Root = styled.div`
  margin: 10px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  font-family: Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
`;
const ContactUs = styled.div`
  div {
    a {
      color: #0065ff;
      text-decoration: none;
      cursor: pointer;
    }
  }
`;
const Bar = styled.div`
  width: 130px;
  border-bottom: 1px solid #dfe1e6;
  height: 1px;
  margin-top: 20px;
  margin-bottom: 10px;
`;
